import React from 'react'
import FontFile from '../shared/font-file'


// Refresh replacement for `sans-serif` (WorkSans-Bold instead of Object Sans).
// The old sans-serif component is intentionally left untouched.
const Word = (props) => {
  return <FontFile
    font={'sans-serif-new'}
    topOffset='0.2em'
    multiplier={1}
    {...props}
    borderColor={props.backCol}

    emojiOffset={-0.1}
    emojiMultiplier={1.1}
  />
}

export default Word
